import { Link } from "@tanstack/react-router";
import { Globe } from "lucide-react";
import { Button } from "@/components/ui/button";

export function RegionalLocationSwitcher({ region }: { region: "uk" | "us" }) {
  return (
    <nav aria-label="Fractional CTO location" className="flex flex-wrap items-center gap-3 text-sm">
      <span className="inline-flex items-center gap-2 font-medium text-subtle">
        <Globe className="size-4" aria-hidden="true" /> Location
      </span>
      <div className="inline-flex items-center gap-1 rounded-lg border border-border-strong bg-background p-1">
        <Button
          asChild
          variant={region === "uk" ? "default" : "ghost"}
          className="h-11 min-w-16 shadow-none"
        >
          <Link
            to="/fractional-cto-uk"
            aria-current={region === "uk" ? "page" : undefined}
            aria-label="UK fractional CTO"
          >
            UK
          </Link>
        </Button>
        <Button
          asChild
          variant={region === "us" ? "default" : "ghost"}
          className="h-11 min-w-16 shadow-none"
        >
          <Link
            to="/fractional-cto-us"
            aria-current={region === "us" ? "page" : undefined}
            aria-label="US fractional CTO"
          >
            US
          </Link>
        </Button>
      </div>
    </nav>
  );
}
